export const VIDEO_POPOUT_NAME = "tsm-video-player";

const VIDEO_POPOUT_FEATURES = "popup=yes,width=960,height=600,resizable=yes,scrollbars=yes";

let retainedVideoWindow: Window | null = null;

export type VideoPopoutResult =
  | { status: "opened" | "reused"; window: Window }
  | { status: "blocked" };

function popoutPath(channelSlug: string): string {
  if (!/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(channelSlug)) {
    throw new Error("Invalid video channel slug");
  }
  return `/video/popout/${channelSlug}`;
}

export function openVideoPopout(channelSlug: string): VideoPopoutResult {
  const path = popoutPath(channelSlug);

  if (retainedVideoWindow && !retainedVideoWindow.closed) {
    retainedVideoWindow.location.href = path;
    retainedVideoWindow.focus();
    return { status: "reused", window: retainedVideoWindow };
  }

  const opened = window.open(path, VIDEO_POPOUT_NAME, VIDEO_POPOUT_FEATURES);
  if (!opened) return { status: "blocked" };

  try {
    opened.opener = null;
  } catch {
    // Some browsers expose a read-only opener. The route stays same-origin.
  }
  retainedVideoWindow = opened;
  opened.focus();
  return { status: "opened", window: opened };
}

export function resetVideoPopoutForTests(): void {
  retainedVideoWindow = null;
}
